import { NgModule } from '@angular/core';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KYMW1707Component } from './kymw1707.component';
import { GetRemindMailTempService } from './api-services/get-remind-mail-temp.service';
import { SendRemindMailInfoService } from './api-services/send-remind-mail-info.service';
import { PlessSharedModule } from 'src/app/shared/pless-shared.module';

/**
 * 過去画像登録画面 モジュール設定クラス
 *
 * @export KYMW1707Module
 * @class KYMW1707Module
 */
@NgModule({
  imports: [
    AppCommonsModule,
    CommonModule,
    FormsModule,
    PlessSharedModule
  ],
  declarations: [
    KYMW1707Component
  ],
  providers: [
    GetRemindMailTempService,
    SendRemindMailInfoService,
  ],
})

export class KYMW1707Module { }
